// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   IconButton,
//   Breadcrumbs,
//   Link,
//   Alert,
//   CircularProgress,
//   Paper,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import FileCopyIcon from "@mui/icons-material/FileCopy"; // added for copy
// import { useATS } from "../context/ATSContext";
// import { jobService } from "../services/jobService";
// import { applicationService } from "../services/applicationService";
// import CandidatePipeline from "../components/CandidatePipeline";
// 
// const JobDetails = () => {
//   const { job_id } = useParams();
//   const navigate = useNavigate();
//   const { triggerRefresh, refreshTrigger } = useATS();
//   const [job, setJob] = useState(null);
//   const [applications, setApplications] = useState([]);
//   const [stages, setStages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [importing, setImporting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   useEffect(() => {
//     if (job_id) {
//       fetchJobDetails();
//       fetchApplications();
//       fetchStages();
//     }
//   }, [job_id, refreshTrigger]);

//   const fetchJobDetails = async () => {
//     try {
//       const response = await jobService.getJobById(job_id);
//       setJob(response.data.data);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load job details");
//     }
//   };

//   const fetchApplications = async () => {
//     try {
//       setLoading(true);
//       const response = await applicationService.getApplicationsByJob(job_id);
//       setApplications(response.data.data || []);
//       setError(null);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load applications");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStages = async () => {
//     try {
//       const response = await jobService.getStagesByJob(job_id);
//       setStages(response.data.data || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleImportCandidates = async () => {
//     try {
//       setImporting(true);
//       await applicationService.importGoogleFormCandidates(job_id);
//       await fetchApplications();
//       triggerRefresh();
//     } catch (err) {
//       console.error(err);
//       alert("Failed to import candidates. Please try again.");
//     } finally {
//       setImporting(false);
//     }
//   };

//   const handleViewCandidate = (candidate) => {
//     setSelectedCandidate(candidate);
//     setDrawerOpen(true);
//   };

//   const handleCloseDrawer = () => {
//     setDrawerOpen(false);
//     setSelectedCandidate(null);
//   };

//   const handleCandidateUpdated = () => {
//     fetchApplications();
//     triggerRefresh();
//   };

//   // ✅ Copy Google Form link to clipboard
//   const handleCopyGoogleFormLink = () => {
//     if (job?.google_form_link) {
//       navigator.clipboard.writeText(job.google_form_link);
//       alert("Google Form link copied to clipboard!");
//     } else {
//       alert("No Google Form link available.");
//     }
//   };

//   if (loading && !job) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//         <CircularProgress sx={{ color: "primary.main" }} />
//       </Box>
//     );
//   }

//   if (error && !job) {
//     return (
//       <Alert severity="error" sx={{ borderRadius: 3 }}>
//         {error}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       <Box sx={{ mb: 4 }}>
//         <Breadcrumbs sx={{ mb: 2 }}>
//           <Link
//             component="button"
//             variant="body2"
//             onClick={() => navigate("/ats")}
//             sx={{ cursor: "pointer", color: "#e4c769ce" }}
//           >
//             Dashboard
//           </Link>
//           <Typography fontSize={14} color="#e2e2e2ce">
//             Job Details
//           </Typography>
//         </Breadcrumbs>

//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 2,
//             flexWrap: "wrap",
//             fontWeight: 800,
//             background: "linear-gradient(135deg, #e4c769 0%, #e4c769 100%)",
//             backgroundClip: "text",
//             WebkitBackgroundClip: "text",
//             color: "transparent",
//             mb: 1,
//           }}
//         >
//           <IconButton
//             onClick={() => navigate("/ats")}
//             sx={{ color: "#e4c769" }}
//           >
//             <ArrowBackIcon />
//           </IconButton>
//           <Typography variant="h5">{job?.title}</Typography>
//           <Button
//             variant="contained"
//             onClick={handleImportCandidates}
//             disabled={importing}
//             startIcon={
//               importing ? <CircularProgress size={20} /> : <RefreshIcon />
//             }
//           >
//             {importing ? "Importing..." : "Get Candidates"}
//           </Button>
//         </Box>
//       </Box>

//       {/* Job Details Card */}
//       {job && (
//         <Card sx={{ mb: 4, borderRadius: 2 }}>
//           <CardContent sx={{ p: 3 }}>
//             <Grid container spacing={4}>
//               <Grid item xs={12} md={8}>
//                 <Typography
//                   fontWeight={600}
//                   variant="subtitle2"
//                   color="#967300"
//                   gutterBottom
//                 >
//                   Description
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   {job.description || "No description provided"}
//                 </Typography>

//                 <Typography
//                   fontWeight={600}
//                   variant="subtitle2"
//                   color="#967300"
//                   gutterBottom
//                 >
//                   Responsibilities
//                 </Typography>
//                 <Typography variant="body1" paragraph>
//                   {job.responsibilities || "No responsibilities listed"}
//                 </Typography>

//                 <Typography
//                   fontWeight={600}
//                   variant="subtitle2"
//                   color="#967300"
//                   gutterBottom
//                 >
//                   Required Skills
//                 </Typography>
//                 <Typography variant="body1">
//                   {job.required_skills || "No skills specified"}
//                 </Typography>
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <Paper
//                   sx={{
//                     p: 2,
//                     bgcolor: "#fcf9f0",
//                     borderRadius: 1.5,
//                     boxShadow: "2px 2px 20px #44350234",
//                   }}
//                 >
//                   <Box
//                     sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//                   >
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Experience
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {job.experience_required || "Not specified"}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Salary Range
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {job.salary_min && job.salary_max
//                           ? `₹${job.salary_min.toLocaleString()} – ₹${job.salary_max.toLocaleString()}`
//                           : "Not specified"}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Total Applicants
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {applications.length}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography variant="body2" color="text.secondary">
//                         Hiring Stages
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {stages.length}
//                       </Typography>
//                     </Box>

//                     {/* WhatsApp Group – open chat in new tab */}
//                     {job.whatsapp_group_link && (
//                       <Button
//                         href={job.whatsapp_group_link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         startIcon={<OpenInNewIcon />}
//                         sx={{ justifyContent: "flex-start", pl: 0 }}
//                       >
//                         WhatsApp Group
//                       </Button>
//                     )}

//                     {/* Google Form – copy link to clipboard */}
//                     {job.google_form_link && (
//                       <Button
//                         onClick={handleCopyGoogleFormLink}
//                         startIcon={<FileCopyIcon />}
//                         sx={{ justifyContent: "flex-start", pl: 0 }}
//                       >
//                         Copy Google Form Link
//                       </Button>
//                     )}

//                     <Chip
//                       label={job.status}
//                       sx={{
//                         bgcolor:
//                           job.status === "ACTIVE"
//                             ? "success.dark"
//                             : "error.dark",
//                         color: "#fff",
//                         width: "fit-content",
//                       }}
//                     />
//                   </Box>
//                 </Paper>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       )}

//       <CandidatesTable
//         applications={applications}
//         stages={stages}
//         loading={loading}
//         onViewCandidate={handleViewCandidate}
//         onRejectCandidate={async (applicationId) => {
//           try {
//             await applicationService.rejectApplication(applicationId, "");
//             fetchApplications();
//             triggerRefresh();
//           } catch (err) {
//             console.error(err);
//             alert("Failed to reject candidate");
//           }
//         }}
//       />

//       <CandidateDrawer
//         open={drawerOpen}
//         onClose={handleCloseDrawer}
//         candidate={selectedCandidate}
//         stages={stages}
//         onUpdate={handleCandidateUpdated}
//       />
//     </Box>
//   );
// };

// export default JobDetails;
// // pages/JobDetails.jsx – Premium Blue Theme, no logic changes
// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   IconButton,
//   Breadcrumbs,
//   Link,
//   Alert,
//   CircularProgress,
//   Paper,
//   alpha,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import FileCopyIcon from "@mui/icons-material/FileCopy";
// import { useATS } from "../context/ATSContext";
// import { jobService } from "../services/jobService";
// import { applicationService } from "../services/applicationService";
// import CandidatePipeline from "../components/CandidatePipeline";
// import CandidateDrawer from "../components/CandidateDrawer";

// // Blue palette (consistent with other pages)
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   800: "#1e40af",
// };

// // Keyframes for fade-up animation
// if (
//   typeof document !== "undefined" &&
//   !document.getElementById("job-details-keyframes")
// ) {
//   const style = document.createElement("style");
//   style.id = "job-details-keyframes";
//   style.textContent = `
//     @keyframes fadeUp {
//       from { opacity: 0; transform: translateY(12px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//   `;
//   document.head.appendChild(style);
// }

// const fontFam = "'Plus Jakarta Sans', 'Inter', sans-serif";

// const JobDetails = () => {
//   const { job_id } = useParams();
//   const navigate = useNavigate();
//   const { triggerRefresh, refreshTrigger } = useATS();
//   const [job, setJob] = useState(null);
//   const [applications, setApplications] = useState([]);
//   const [stages, setStages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [importing, setImporting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   useEffect(() => {
//     if (job_id) {
//       fetchJobDetails();
//       fetchApplications();
//       fetchStages();
//     }
//   }, [job_id, refreshTrigger]);

//   const fetchJobDetails = async () => {
//     try {
//       const response = await jobService.getJobById(job_id);
//       setJob(response.data.data);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load job details");
//     }
//   };

//   const fetchApplications = async () => {
//     try {
//       setLoading(true);
//       const response = await applicationService.getApplicationsByJob(job_id);
//       setApplications(response.data.data || []);
//       setError(null);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load applications");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStages = async () => {
//     try {
//       const response = await jobService.getStagesByJob(job_id);
//       setStages(response.data.data || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleImportCandidates = async () => {
//     try {
//       setImporting(true);
//       await applicationService.importGoogleFormCandidates(job_id);
//       await fetchApplications();
//       triggerRefresh();
//     } catch (err) {
//       console.error(err);
//       alert("Failed to import candidates. Please try again.");
//     } finally {
//       setImporting(false);
//     }
//   };

//   const handleViewCandidate = (candidate) => {
//     setSelectedCandidate(candidate);
//     setDrawerOpen(true);
//   };

//   const handleCloseDrawer = () => {
//     setDrawerOpen(false);
//     setSelectedCandidate(null);
//   };

//   const handleCandidateUpdated = () => {
//     fetchApplications();
//     triggerRefresh();
//   };

//   const handleCopyGoogleFormLink = () => {
//     if (job?.google_form_link) {
//       navigator.clipboard.writeText(job.google_form_link);
//       alert("Google Form link copied to clipboard!");
//     } else {
//       alert("No Google Form link available.");
//     }
//   };

//   if (loading && !job) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//         <CircularProgress sx={{ color: BLUE[600] }} />
//       </Box>
//     );
//   }

//   if (error && !job) {
//     return (
//       <Alert severity="error" sx={{ borderRadius: "16px" }}>
//         {error}
//       </Alert>
//     );
//   }

//   return (
//     <Box sx={{ fontFamily: fontFam }}>
//       <Box sx={{ mb: 4, animation: "fadeUp 0.4s ease both" }}>
//         <Breadcrumbs sx={{ mb: 2 }}>
//           <Link
//             component="button"
//             variant="body2"
//             onClick={() => navigate("/ats")}
//             sx={{
//               cursor: "pointer",
//               color: "-moz-initial",
//               textDecoration: "none",
//               fontWeight: 500,
//               color: "#fff",
//             }}
//           >
//             Dashboard
//           </Link>
//           <Typography sx={{ color: "#e2dfdf", fontSize: "0.85rem" }}>
//             Job Details
//           </Typography>
//         </Breadcrumbs>

//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 2,
//             flexWrap: "wrap",
//             mb: 1,
//           }}
//         >
//           <IconButton onClick={() => navigate("/ats")} sx={{ color: "#fff" }}>
//             <ArrowBackIcon />
//           </IconButton>
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 800,

//               color: "#FFFF",
//             }}
//           >
//             {job?.title}
//           </Typography>
//           <Button
//             variant="contained"
//             onClick={handleImportCandidates}
//             disabled={importing}
//             startIcon={
//               importing ? (
//                 <CircularProgress size={20} sx={{ color: "#fff" }} />
//               ) : (
//                 <RefreshIcon />
//               )
//             }
//             sx={{
//               borderRadius: "40px",
//               textTransform: "none",
//               fontWeight: 600,
//               color: "#fff",
//               background: "#037e8f ",
//               boxShadow: `0 4px 12px ${alpha(BLUE[500], 0.3)}`,
//               "&:hover": {
//                 transform: "translateY(-1px)",
//                 boxShadow: `0 6px 16px ${alpha(BLUE[500], 0.4)}`,
//                 background: "#5fc1ce ",
//               },
//             }}
//           >
//             {importing ? "Importing..." : "Get Candidates"}
//           </Button>
//         </Box>
//       </Box>

//       {/* Job Details Card */}
//       {job && (
//         <Card
//           sx={{
//             mb: 4,
//             borderRadius: "24px",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
//             border: `1px solid ${BLUE[100]}`,
//             transition: "box-shadow 0.2s",
//             "&:hover": { boxShadow: `0 12px 28px ${alpha(BLUE[500], 0.08)}` },
//             animation: "fadeUp 0.45s ease both",
//           }}
//         >
//           <CardContent sx={{ p: 3 }}>
//             <Grid container spacing={4}>
//               <Grid item xs={12} md={8}>
//                 <Typography
//                   fontWeight={700}
//                   variant="subtitle1"
//                   sx={{ color: "#037e8f", mb: 0.5 }}
//                 >
//                   Description
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   paragraph
//                   sx={{ color: "#334155", lineHeight: 1.6 }}
//                 >
//                   {job.description || "No description provided"}
//                 </Typography>

//                 <Typography
//                   fontWeight={700}
//                   variant="subtitle1"
//                   sx={{ color: "#037e8f", mb: 0.5, mt: 1 }}
//                 >
//                   Responsibilities
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   paragraph
//                   sx={{ color: "#334155", lineHeight: 1.6 }}
//                 >
//                   {job.responsibilities || "No responsibilities listed"}
//                 </Typography>

//                 <Typography
//                   fontWeight={700}
//                   variant="subtitle1"
//                   sx={{ color: "#037e8f", mb: 0.5, mt: 1 }}
//                 >
//                   Required Skills
//                 </Typography>
//                 <Typography variant="body1" sx={{ color: "#334155" }}>
//                   {job.required_skills || "No skills specified"}
//                 </Typography>
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 2.5,
//                     bgcolor: "#e9f8fa",
//                     borderRadius: "20px",
//                     border: `1px solid #037f8f50`,
//                   }}
//                 >
//                   <Box
//                     sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//                   >
//                     <Box>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#64748b", fontWeight: 500 }}
//                       >
//                         Experience
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         fontWeight={600}
//                         sx={{ color: "#0f172a" }}
//                       >
//                         {job.experience_required || "Not specified"}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#64748b", fontWeight: 500 }}
//                       >
//                         Salary Range
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         fontWeight={600}
//                         sx={{ color: "#0f172a" }}
//                       >
//                         {job.salary_min && job.salary_max
//                           ? `₹${job.salary_min.toLocaleString()} – ₹${job.salary_max.toLocaleString()}`
//                           : "Not specified"}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#64748b", fontWeight: 500 }}
//                       >
//                         Total Applicants
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         fontWeight={600}
//                         sx={{ color: "#0f172a" }}
//                       >
//                         {applications.length}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#64748b", fontWeight: 500 }}
//                       >
//                         Hiring Stages
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         fontWeight={600}
//                         sx={{ color: "#0f172a" }}
//                       >
//                         {stages.length}
//                       </Typography>
//                     </Box>

//                     {job.whatsapp_group_link && (
//                       <Button
//                         href={job.whatsapp_group_link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         startIcon={<OpenInNewIcon />}
//                         sx={{
//                           justifyContent: "flex-start",
//                           pl: 0,
//                           color: "#037e8f",
//                           textTransform: "none",
//                         }}
//                       >
//                         WhatsApp Group
//                       </Button>
//                     )}

//                     {job.google_form_link && (
//                       <Button
//                         onClick={handleCopyGoogleFormLink}
//                         startIcon={<FileCopyIcon />}
//                         sx={{
//                           justifyContent: "flex-start",
//                           pl: 0,
//                           color: "#037e8f",
//                           textTransform: "none",
//                         }}
//                       >
//                         Copy Google Form Link
//                       </Button>
//                     )}

//                     <Chip
//                       label={job.status}
//                       sx={{
//                         bgcolor:
//                           job.status === "ACTIVE" ? "#037e8f" : "#dc2626",
//                         color: "#fff",
//                         fontWeight: 600,
//                         borderRadius: "20px",
//                         width: "fit-content",
//                       }}
//                     />
//                   </Box>
//                 </Paper>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       )}

//       <CandidatesTable
//         applications={applications}
//         stages={stages}
//         loading={loading}
//         onViewCandidate={handleViewCandidate}
//         onRejectCandidate={async (applicationId) => {
//           try {
//             await applicationService.rejectApplication(applicationId, "");
//             fetchApplications();
//             triggerRefresh();
//           } catch (err) {
//             console.error(err);
//             alert("Failed to reject candidate");
//           }
//         }}
//       />

//       <CandidateDrawer
//         open={drawerOpen}
//         onClose={handleCloseDrawer}
//         candidate={selectedCandidate}
//         stages={stages}
//         onUpdate={handleCandidateUpdated}
//       />
//     </Box>
//   );
// };

// export default JobDetails;
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  IconButton,
  Alert,
  CircularProgress,
  Stack,
  Menu,
  MenuItem,
  Divider,
  Tooltip,
} from "@mui/material";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import JobStatusControl from "../components/JobStatusControl";
import DeleteJobDialog from "../components/DeleteJobDialog";
import ClearCandidatesDialog from "../components/ClearCandidatesDialog";
import PersonRemoveRoundedIcon from "@mui/icons-material/PersonRemoveRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";

import { useATS } from "../context/ATSContext";
import { jobService } from "../services/jobService";
import { applicationService } from "../services/applicationService";

import CandidatePipeline from "../components/CandidatePipeline";
import BulkResumeUpload from "../components/BulkResumeUpload";
import IntakeSetupPanel from "../components/IntakeSetupPanel";
import JobSwitcher from "../components/JobSwitcher";

const fontFam = "'Inter', 'Plus Jakarta Sans', sans-serif";

if (typeof document !== "undefined") {
  // Replaced, not skipped-if-present.
  //
  // This was `if (!document.getElementById(...))`, which meant the first version
  // of this stylesheet to reach a page was the only one that ever applied. Every
  // subsequent edit was invisible until a hard reload — the tab rail kept its
  // old underline-and-margin styling long after it had been rewritten, which
  // reads as "the CSS change did nothing" rather than "the CSS was never
  // inserted".
  const existing = document.getElementById("job-details-new-ui");
  if (existing) existing.remove();

  const style = document.createElement("style");

  style.id = "job-details-new-ui";

  style.textContent = `
  
  @keyframes fadeUp{
    from{
      opacity:0;
      transform:translateY(10px);
    }
    to{
      opacity:1;
      transform:translateY(0);
    }
  }

  .jd-page{
    padding:12px 14px 20px;
    border-radius:10px;
    background:#f7f9fc;
    min-height:100vh;
    font-family:${fontFam};
  }

  /* One row: identity left, actions right, both vertically centred. It was
     flex-start with the actions in a tall vertical stack, which is where most
     of the empty space at the top of this page came from. */
  .jd-topbar{
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:16px;
    margin-bottom:6px;
    flex-wrap:wrap;
    animation:fadeUp .4s ease both;
  }

  .jd-breadcrumb{
    font-size:12px;
    color:#98a2b3;
    font-weight:500;
  }

  .jd-title{
    font-size:23px !important;
    font-weight:800 !important;
    color:#101828;
    margin:0 !important;
    /* An explicit line box. Without it the Typography's own line-height made
       the title taller than the chip and the tabs beside it, so "centre" put
       all three on slightly different baselines. */
    line-height:32px !important;
    letter-spacing:-0.4px;
  }

  .jd-sub{
    color:#667085;
    font-size:14px;
    font-weight:500;
  }

  .jd-action-wrap{
    display:flex;
    gap:10px;
    align-items:center;
    flex-wrap:wrap;
  }

  .jd-outline-btn{
    height:38px;
    font-size:13.5px !important;
    border-radius:9px !important;
    border:1px solid #d0d5dd !important;
    background:#fff !important;
    color:#344054 !important;
    padding:0 18px !important;
    text-transform:none !important;
    font-weight:700 !important;
    box-shadow:none !important;
  }

  .jd-filled-btn{
    height:38px;
    font-size:13.5px !important;
    border-radius:9px !important;
    background:#0b8a8f !important;
    color:#fff !important;
    padding:0 18px !important;
    text-transform:none !important;
    font-weight:700 !important;
    box-shadow:0 8px 20px rgba(11,138,143,.18) !important;
  }

  .jd-card{
    border-radius:12px !important;
    border:1px solid #e9edf5 !important;
    box-shadow:0 2px 12px rgba(16,24,40,.04) !important;
    overflow:hidden;
    animation:fadeUp .45s ease both;
  }

  .jd-section-card{
    border-radius:10px !important;
    border:1px solid #edf1f7 !important;
    box-shadow:none !important;
    height:100%;
    background:#fff;
  }

  .jd-section-title{
    font-size:15px !important;
    font-weight:800 !important;
    color:#344054;
    margin-bottom:14px !important;
  }

  .jd-body{
    color:#667085;
    line-height:1.8;
    font-size:14px;
  }

  .jd-skill-wrap{
    display:flex;
    flex-wrap:wrap;
    gap:10px;
  }

  .jd-skill{
    background:#ecfdff !important;
    color:#0b8a8f !important;
    border-radius:7px !important;
    font-weight:700 !important;
    font-size:12px !important;
    height:32px !important;
  }

  .jd-mini-card{
    border-radius:10px;
    overflow:hidden;
    background:#f8fbfc;
    border:1px solid #e5edf2;
    padding:18px;
    position:relative;
    height:100%;
  }

  .jd-progress{
    width:100%;
    height:8px;
    border-radius:999px;
    background:#dceff0;
    overflow:hidden;
    margin-top:14px;
  }

  /* A segmented control, not a rail.
     It was a full-width underlined rail on its own row; inline beside the
     status chip it has to read as a pair of buttons instead, or it looks like
     two stray words floating next to the job title. */
  .jd-tabrail{
    display:inline-flex;
    gap:2px;
    align-items:center;
    /* 32px to match .jd-title's line box exactly, so the three things on this
       row share one centre line instead of nearly sharing one. */
    height:32px;
    margin-left:10px;
    padding:3px;
    border-radius:9px;
    background:#eef2f6;
  }

  .jd-tab{
    display:flex;
    align-items:center;
    height:100%;
    padding:0 12px;
    font-size:13px;
    font-weight:650;
    color:#667085;
    cursor:pointer;
    user-select:none;
    white-space:nowrap;
    border-radius:7px;
    transition:color .16s, background .16s, box-shadow .16s;
  }

  .jd-tab:hover{
    color:#101828;
  }

  .jd-tab:focus-visible{
    outline:2px solid #0b8a8f;
    outline-offset:1px;
  }

  .jd-tab-on{
    color:#0b8a8f;
    background:#fff;
    box-shadow:0 1px 3px rgba(16,24,40,.10);
  }

  .jd-tab-count{
    margin-left:6px;
    font-size:11.5px;
    font-weight:700;
    color:#98a2b3;
  }

  .jd-progress-fill{
    width:72%;
    height:100%;
    background:#0b8a8f;
    border-radius:999px;
  }

  `;
  document.head.appendChild(style);
}

const JobDetails = () => {
  const { job_id } = useParams();

  const navigate = useNavigate();

  // store_id feeds the job switcher on the title, which lists the store's
  // other jobs.
  const { triggerRefresh, refreshTrigger, store_id } = useATS();

  const [job, setJob] = useState(null);
  const [applications, setApplications] = useState([]);
  // `stages` went with the drawer, which was the only thing that read it.
  // The pipeline fetches its own rounds, so this was one extra request per
  // page load whose result nothing looked at.


  const [loading, setLoading] = useState(true);
  const [importing, setImporting] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [clearOpen, setClearOpen] = useState(false);

  // Set the moment a delete succeeds. A fetch already in flight, or an effect
  // that fires between the delete and the unmount, must not resurrect the
  // error screen for a job we are deliberately walking away from.
  const deletedRef = useRef(false);
  // Bumped after an upload so the pipeline below refetches and the new
  // candidates appear without a page reload.
  const [pipelineKey, setPipelineKey] = useState(0);

  const [error, setError] = useState(null);

  // The overflow menu in the header. Rare and destructive actions live in here
  // rather than as buttons, which is what took ~160px of vertical space off the
  // top of this page.
  const [menuAnchor, setMenuAnchor] = useState(null);

  // Candidates by default. See the tab rail below for why.
  const [tab, setTab] = useState("candidates");
  // Sticks once true. The description tab mounts on first visit and stays
  // mounted, so its intake panel costs one fetch the first time somebody opens
  // it rather than one on every page load.
  const [descriptionSeen, setDescriptionSeen] = useState(false);
  useEffect(() => {
    if (tab === "description") setDescriptionSeen(true);
  }, [tab]);

  // selectedCandidate / drawerOpen went with the drawer. A candidate is a
  // route now, so which one is being looked at lives in the URL — which is why
  // it can be linked to, bookmarked and reloaded.

  // ── Switching jobs must not carry the last one's UI across ───────────────
  //
  // The job switcher on the title changes the ROUTE PARAM, and React Router
  // keeps this component mounted when only a param changes. So every piece of
  // per-job state below survives the switch, and each one is wrong the moment
  // it does:
  //
  //   the overflow menu stays open over a page that has changed underneath it;
  //   "Delete job" and "Remove all candidates" stay open, now pointed at a
  //   different job than the one they were opened for — which is the dangerous
  //   one, because the confirmation text is rebuilt from the new job while the
  //   reader has already decided to press the button.
  //
  // The candidate drawer used to be reset here too, and it was the worst of
  // them: it kept showing somebody from the job you had just left. It is gone —
  // a candidate is a route of its own now, so a job switch cannot leave one
  // half-open behind it.
  //
  // `deletedRef` is cleared too: it latches true after a delete to stop
  // in-flight fetches resurrecting an error screen, and it would otherwise keep
  // this page permanently blank if anything ever navigated to another job
  // without a remount.
  useEffect(() => {
    setMenuAnchor(null);
    setDeleteOpen(false);
    setClearOpen(false);
    setBulkOpen(false);
    deletedRef.current = false;
  }, [job_id]);

  useEffect(() => {
    // Nothing to fetch for a job we just deleted. Guarded here as well as
    // inside fetchJobDetails, so the two sibling fetches cannot fire either —
    // they hit the same dead id and set their own errors.
    if (job_id && !deletedRef.current) {
      fetchJobDetails();
      fetchApplications();
    }
  }, [job_id, refreshTrigger]);

  const fetchJobDetails = async () => {
    if (deletedRef.current) return;
    try {
      const response = await jobService.getJobById(job_id);

      // This API reports failure in the BODY while still returning HTTP 200
      // ({ statusCode: 404, success: false } with no `data`), so axios does not
      // throw and the catch below never runs. A deleted job therefore used to
      // arrive here as `undefined` and get stored as the job: loading finished,
      // error stayed null, and the render fell through to `job.whatsapp_group_link`
      // on undefined. That TypeError blanks the page — which reads to a user as
      // the whole app having crashed, with nothing in the console pointing here.
      //
      // Any route holding a job id outlives the job itself: an open tab, a
      // bookmark, a browser-history entry. Deleting a job must not be able to
      // white-screen the app.
      const found = response.data?.data;
      if (!found) {
        setJob(null);
        setError(response.data?.statusMessage || "Job not found");
        return;
      }

      setJob(found);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Failed to load job details");
    }
  };

  const fetchApplications = async () => {
    try {
      setLoading(true);

      const response = await applicationService.getApplicationsByJob(job_id);

      setApplications(response.data.data || []);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Failed to load applications");
    } finally {
      setLoading(false);
    }
  };

  const handleImportCandidates = async () => {
    try {
      setImporting(true);

      await applicationService.importGoogleFormCandidates(job_id);

      await fetchApplications();

      triggerRefresh();
    } catch (err) {
      console.error(err);
      alert("Failed to import candidates");
    } finally {
      setImporting(false);
    }
  };

  // Opens the candidate's own page.
  //
  // This used to set state and open a 55%-wide drawer. The drawer was the
  // wrong shape for what it held — identity, resume evidence, manual scoring,
  // sixteen recorded answers, a competency breakdown and an audit trail — and
  // it was one of TWO candidate surfaces, the other being an interview-only
  // console that 404'd for anybody who had not interviewed.
  const handleViewCandidate = (candidate) => {
    if (!candidate?.application_id) return;
    navigate(`/ats/candidate/${candidate.application_id}`);
  };

  // handleCloseDrawer and handleCandidateUpdated went with the drawer. The
  // first called setters that no longer exist, so it would have thrown the
  // moment anything reached it; the second is what the pipeline's own
  // onChanged already does.

  const handleCopyGoogleFormLink = () => {
    if (job?.google_form_link) {
      navigator.clipboard.writeText(job.google_form_link);

      alert("Google Form link copied");
    }
  };

  if (loading && !job) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 12,
        }}
      >
        <CircularProgress sx={{ color: "#0b8a8f" }} />
      </Box>
    );
  }

  // Deliberately `!job` rather than `error && !job`. The three fetches in the
  // mount effect run concurrently, and fetchApplications clears the error on
  // success — for a deleted job it succeeds with an empty list and wipes the
  // "Job not found" that fetchJobDetails just set. That left no job, no error
  // and no loading, so the render fell through to `job.whatsapp_group_link`
  // and blanked the page.
  //
  // Keying on the thing the render below actually requires — a job — makes that
  // crash unreachable no matter which fetch resolves last, or which future one
  // clears the error next.
  if (!job) {
    // A bare alert is a dead end. You reach this from a bookmark, a back
    // button, or a job somebody else deleted while you had it open — and in
    // every one of those the next thing you want is the job list, not a
    // sentence and an empty page.
    return (
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Alert
          severity="error"
          sx={{ borderRadius: "18px" }}
          action={
            <Button
              size="small"
              onClick={() => navigate("/ats")}
              sx={{ textTransform: "none", fontWeight: 700, whiteSpace: "nowrap" }}
            >
              Back to jobs
            </Button>
          }
        >
          {error || "This job no longer exists."}
        </Alert>
      </Box>
    );
  }

  return (
    <Box className="jd-page">
      {/* ── TOP ──────────────────────────────────────────────────────────────
          Two everyday buttons on the right, everything else in an overflow menu.

          This used to be four full-width buttons stacked vertically — Get
          candidates, Upload resumes, Remove all candidates, Delete job — which
          pushed the candidate list a couple of hundred pixels down the page and
          gave "delete this job forever" the same visual weight as the button
          people press every morning. Two of the four are rare and one is
          irreversible, so they live behind the ⋯ where a rare action belongs. */}

      <Box className="jd-topbar">
        <Box sx={{ minWidth: 0 }}>
          {/* "Jobs" is a link now. It was plain text, so the only way back to
              the list was the browser's back button — and a breadcrumb that
              looks clickable and is not is worse than no breadcrumb. */}
          <Typography className="jd-breadcrumb">
            <Box
              component="span"
              onClick={() => navigate("/ats")}
              sx={{
                cursor: "pointer",
                "&:hover": { color: "#037e8f", textDecoration: "underline" },
              }}
            >
              Jobs
            </Box>
            &nbsp; &gt; &nbsp; {job?.title}
          </Typography>

          {/* Title, status AND the two tabs on ONE line.
              Each of these was its own row: a 30px title, a status chip under
              it, and a full-width tab rail under that — about 110px of header
              to say three things that together are shorter than the job's name.
              They read as one unit anyway ("this job, open, showing
              candidates"), so they sit as one. */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              flexWrap: "wrap",
              mt: 0.25,
            }}
          >
            {/* The title IS the job switcher.
                Getting from one job to the next used to mean: breadcrumb to
                Jobs, find the card among however many exist, click in — three
                navigations and a visual search to do the thing recruiters do
                most, which is the same review on the next role.
                The title is the right home for it: it already answers "which
                job am I looking at", which is the question a switcher answers.
                A separate dropdown beside it would put the job's identity in
                two places and leave the reader to work out which is which. */}
            <JobSwitcher
              currentJob={job}
              storeId={store_id}
              onPick={(next) => {
                // null is the "See all jobs" row.
                if (!next) {
                  navigate("/ats");
                  return;
                }
                // A route change, not a local state swap. Every panel on this
                // page keys off `job_id` from the URL — the pipeline, the
                // intake setup, the candidate drawer — so navigating is what
                // makes all of them reload for the new job. Swapping `job` in
                // state would leave the candidate list showing the previous
                // job's people under the new job's name.
                navigate(`/ats/job/${next.id}`);
              }}
            />
            {job && (
              <JobStatusControl
                jobId={job.id}
                status={job.status}
                onChange={(next) => setJob((j) => (j ? { ...j, status: next } : j))}
              />
            )}

            <Box className="jd-tabrail">
              {[
                { key: "candidates", label: "Candidates", count: applications.length },
                { key: "description", label: "Job description" },
              ].map((t) => (
                <Box
                  key={t.key}
                  role="tab"
                  aria-selected={tab === t.key}
                  tabIndex={0}
                  onClick={() => setTab(t.key)}
                  onKeyDown={(e) => {
                    // A div acting as a tab has to answer the keyboard like one,
                    // or the whole page below becomes unreachable without a mouse.
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setTab(t.key);
                    }
                  }}
                  className={`jd-tab${tab === t.key ? " jd-tab-on" : ""}`}
                >
                  {t.label}
                  {t.count != null && <span className="jd-tab-count">{t.count}</span>}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box className="jd-action-wrap">
          <Button
            startIcon={
              importing ? (
                <CircularProgress size={16} sx={{ color: "#fff" }} />
              ) : (
                <ShareOutlinedIcon sx={{ fontSize: 18 }} />
              )
            }
            onClick={handleImportCandidates}
            disabled={importing}
            className="jd-filled-btn"
          >
            {importing ? "Importing…" : "Get candidates"}
          </Button>

          {/* The other way people get into a job: a folder of resumes and no
              form. Common enough to stay out of the menu. */}
          <Button
            startIcon={<UploadFileRoundedIcon sx={{ fontSize: 18 }} />}
            onClick={() => setBulkOpen(true)}
            className="jd-outline-btn"
          >
            Upload resumes
          </Button>

          {/* The JD document, where somebody looking at the job would reach for
              it. A plain link rather than a fetch-and-blob: the blob URL is
              already public-read, and routing it through the app would only add
              a way for the download to fail. */}
          {job.jd_pdf_url && (
            <Button
              component="a"
              href={job.jd_pdf_url}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<PictureAsPdfOutlinedIcon sx={{ fontSize: 18 }} />}
              className="jd-outline-btn"
            >
              Job description
            </Button>
          )}

          <Tooltip title="More">
            <IconButton
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              sx={{
                width: 38,
                height: 38,
                border: "1px solid #d0d5dd",
                borderRadius: "9px",
                color: "#475467",
                "&:hover": { bgcolor: "#f2f5f9" },
              }}
            >
              <MoreHorizRoundedIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={() => setMenuAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: { borderRadius: 2.5, minWidth: 236, boxShadow: "0 8px 28px rgba(16,24,40,.12)" },
            }}
          >
            {job.google_form_link && (
              <MenuItem
                onClick={() => {
                  setMenuAnchor(null);
                  handleCopyGoogleFormLink();
                }}
                sx={{ fontSize: 14, gap: 1.5 }}
              >
                <FileCopyIcon sx={{ fontSize: 18, color: "#667085" }} />
                Copy Google Form link
              </MenuItem>
            )}

            {job.whatsapp_group_link && (
              <MenuItem
                component="a"
                href={job.whatsapp_group_link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuAnchor(null)}
                sx={{ fontSize: 14, gap: 1.5 }}
              >
                <OpenInNewIcon sx={{ fontSize: 18, color: "#667085" }} />
                Open WhatsApp group
              </MenuItem>
            )}

            {(job.google_form_link || job.whatsapp_group_link) && <Divider />}

            {/* Clearing the pipeline is the everyday version of deleting: a form
                that ran twice, an import that pulled the wrong sheet. It sits
                above "Delete job" because it is the one people actually want,
                and because reaching for the destructive one to fix an import
                would cost them every round they had set up. */}
            {applications.length > 0 && (
              <MenuItem
                onClick={() => {
                  setMenuAnchor(null);
                  setClearOpen(true);
                }}
                sx={{ fontSize: 14, gap: 1.5, color: "#b45309" }}
              >
                <PersonRemoveRoundedIcon sx={{ fontSize: 18 }} />
                Remove all candidates
              </MenuItem>
            )}

            {/* Last, and the only red thing on the page. Deleting a job is rare
                and irreversible; the confirmation carries the danger, but it
                should not be sitting under the cursor of somebody reaching for
                "Upload resumes". */}
            <MenuItem
              onClick={() => {
                setMenuAnchor(null);
                setDeleteOpen(true);
              }}
              sx={{ fontSize: 14, gap: 1.5, color: "#b91c1c" }}
            >
              <DeleteOutlineRoundedIcon sx={{ fontSize: 18 }} />
              Delete job
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      {/* Hidden rather than unmounted.
          The pipeline holds a search box, a date range, a set of ticked
          checkboxes and an expanded row — a whole working state that somebody
          is halfway through. Unmounting it to glance at the job description
          throws all of that away and refetches the list on the way back. */}
      <Box sx={{ display: tab === "candidates" ? "block" : "none" }}>
        <CandidatePipeline
          // Keyed on the JOB as well as the upload counter, so switching jobs
          // from the title remounts the pipeline instead of reusing it.
          //
          // Its internals reload on a jobId change already, but the component
          // also holds per-job UI state that a param change would carry across:
          // the round tab, the tick-box selection, the expanded row, the page
          // number and the date filter. Reusing it means landing on the new job
          // with the previous one's filters applied and a selection of
          // application ids that are not on this job.
          key={`${job_id}:${pipelineKey}`}
          jobId={job_id}
          onOpenCandidate={handleViewCandidate}
          // A delete changes the counts on the job header and in the list behind
          // it, and the pipeline reloads itself but knows nothing about either.
          onChanged={() => {
            fetchApplications();
            triggerRefresh();
          }}
          onRejectCandidate={async (applicationId, reason) => {
            // Errors are re-thrown rather than swallowed into an alert(): the
            // reject dialog is still open and holds the reason that was typed,
            // and it reports the failure there so the text is not lost.
            //
            // `reason` is required by the server, which refuses with 400 and an
            // explanation if it is missing. This used to pass "" and the server
            // stored the placeholder "Candidate rejected" — a fabricated reason
            // that reads in the audit trail exactly like a real one.
            await applicationService.rejectApplication(applicationId, reason);
            fetchApplications();
            triggerRefresh();
          }}
          onUnrejectCandidate={async (applicationId) => {
            await applicationService.unrejectApplication(applicationId);
            fetchApplications();
            triggerRefresh();
          }}
        />
      </Box>

      {/* The opposite trade-off to the panel above, for the opposite reason.
          IntakeSetupPanel fetches its status on mount, and most visits to this
          page never open this tab — so it is mounted on first use and kept
          mounted after that, rather than costing a request on every page load
          for a panel nobody looked at. */}
      {descriptionSeen && (
        <Box sx={{ display: tab === "description" ? "block" : "none" }}>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {/* LEFT */}

            <Grid item xs={12} md={8}>
              <Stack spacing={3}>
                {/* description */}

                <Card className="jd-section-card">
                  <CardContent sx={{ p: 3 }}>
                    <Typography className="jd-section-title">
                      Job Description
                    </Typography>

                    <Typography className="jd-body">
                      {job.description || "No description provided"}
                    </Typography>
                  </CardContent>
                </Card>

                {/* The attached JD.
                    Sits directly under the description because that is what it
                    is — the long-form version of the text above it — and
                    because "is a JD attached to this posting?" is a question
                    with no other answer on this page. It also states that
                    candidates receive it, which a filename alone does not. */}
                {job.jd_pdf_url && (
                  <Card className="jd-section-card">
                    <CardContent sx={{ p: 3 }}>
                      <Typography className="jd-section-title">
                        Attached Job Description
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          mt: 1,
                        }}
                      >
                        <PictureAsPdfOutlinedIcon
                          sx={{ fontSize: 26, color: "#0c8a9b", flexShrink: 0 }}
                        />
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography
                            component="a"
                            href={job.jd_pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              display: "block",
                              fontSize: 14,
                              fontWeight: 600,
                              color: "#0c8a9b",
                              textDecoration: "none",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              "&:hover": { textDecoration: "underline" },
                            }}
                          >
                            {job.jd_pdf_name || "Job description (PDF)"}
                          </Typography>
                          <Typography
                            sx={{ fontSize: 12, color: "#667085", mt: 0.2 }}
                          >
                            Sent to candidates with their interview link.
                          </Typography>
                        </Box>
                        <Button
                          component="a"
                          href={job.jd_pdf_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
                          className="jd-outline-btn"
                        >
                          Open
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                )}

                {/* responsibilities */}

                <Card className="jd-section-card">
                  <CardContent sx={{ p: 3 }}>
                    <Typography className="jd-section-title">
                      Responsibilities
                    </Typography>

                    <Typography className="jd-body">
                      {job.responsibilities || "No responsibilities provided"}
                    </Typography>
                  </CardContent>
                </Card>
              </Stack>
            </Grid>

            {/* RIGHT */}

            <Grid item xs={12} md={4}>
              <Stack spacing={3}>
                {/* skills */}

                <Card className="jd-section-card">
                  <CardContent sx={{ p: 3 }}>
                    <Typography className="jd-section-title">
                      Required Skills
                    </Typography>

                    <Box className="jd-skill-wrap">
                      {job.required_skills?.split(",")?.filter(Boolean)?.length ? (
                        job.required_skills
                          .split(",")
                          .filter(Boolean)
                          .map((skill, idx) => (
                            <Chip key={idx} label={skill.trim()} className="jd-skill" />
                          ))
                      ) : (
                        // Was a hardcoded React/Node/TypeScript fallback, which
                        // is worse than blank: a warehouse job with no skills
                        // filled in displayed three it had never asked for, and
                        // there is nothing on screen saying they are made up.
                        <Typography className="jd-body">
                          No required skills listed for this job.
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Stack>
            </Grid>
          </Grid>

          {/* INTAKE — Google Form setup, mapping, script and staleness. Read
              once when the job is created, so it sits under the description
              rather than above the candidate list. */}
          <IntakeSetupPanel jobId={job_id} onImported={fetchApplications} />
        </Box>
      )}

      <BulkResumeUpload
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        jobId={job_id}
        jobTitle={job?.title}
        onDone={() => setPipelineKey((k) => k + 1)}
      />

      {/* Same dialog the job card uses. One copy, so the two places cannot
          drift apart about what survives a clear. */}
      <ClearCandidatesDialog
        open={clearOpen}
        jobId={job_id}
        jobTitle={job?.title}
        count={applications.length}
        onClose={() => setClearOpen(false)}
        onDone={() => {
          setClearOpen(false);
          fetchApplications();
          setPipelineKey((k) => k + 1);
          triggerRefresh();
        }}
      />

      <DeleteJobDialog
        open={deleteOpen}
        jobId={job_id}
        jobTitle={job?.title}
        onClose={() => setDeleteOpen(false)}
        onDeleted={() => {
          setDeleteOpen(false);

          // Mark it gone BEFORE navigating.
          //
          // This effect refetches on every refreshTrigger change, and the
          // navigation is not instant. Calling triggerRefresh() here — which
          // is what this used to do — sent this page off to fetch the job it
          // had just deleted, got the 404, and painted "This job no longer
          // exists" over the top on the way out.
          //
          // triggerRefresh is gone too: the Dashboard fetches its own list on
          // mount, so there was nothing for it to do except wake this page up.
          deletedRef.current = true;
          navigate("/ats");
        }}
      />

      {/* DRAWER */}

      {/* The CandidateDrawer was here. Replaced by /ats/candidate/:id — see
          handleViewCandidate. The component file still exists and is no longer
          imported by anything. */}
    </Box>
  );
};

export default JobDetails;
